import React from 'react';
import SvgIcon from '../SvgIcon';
import { TabStyled, IconWrapper } from './tab.styled';

interface TabProps {
  value?: string;
  active?: boolean;
  placement?: string;
  icon?: React.ReactNode;
  onClick?: (event: React.MouseEvent<HTMLElement>, value: string) => void;
  children?: React.ReactNode | React.ReactNode[];
}

const Tab = ({
  value,
  icon,
  active,
  placement,
  onClick,
  children,
  ...rest
}: TabProps) => {
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    onClick(event, value);
  };

  return (
    <TabStyled
      active={active}
      onClick={handleClick}
      placement={placement}
      {...rest}
    >
      {icon ? (
        <IconWrapper>
          <SvgIcon
            color={active ? 'primary' : undefined}
            size='medium'
            icon={icon}
          />
        </IconWrapper>
      ) : null}
      {children}
    </TabStyled>
  );
};

export default Tab;
